import projection from '../generated/pwm501f1.json';
import { AcceptanceManifest } from '../types';

export const pwm501f1AcceptanceManifest = projection as AcceptanceManifest;
